module Meevo.Plugins.Client {
    import SettingsDto = Meevo.Model.SettingsDto;
    "use strict";

    /**
    * New Charts Section of Client Profile
    */
    export class ClientChartsSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Client> {

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            protected identityService: Meevo.Components.Common.IIdentityService = null,
            noun: Meevo.Model.NounEnum = null,
            appSettings?: Components.Common.IAppSettings,
            sectionSecurityKey?: string,
            protected translateService?: angular.translate.ITranslateService,
            protected contextParams?: Meevo.IContextParams,

        ) {
            super(
                sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                identityService,
                noun,
                appSettings,
                sectionSecurityKey,
                translateService
            );
            this.isInteropContext = true;
        }

        selected() {
            let period = 0;
            let targetRoute = '';
            let mode = null;
            let sourceModule = null;
            let clientChartId = '0';
            let locationId = '0';
            let chartdefinitionId = '0';
            let chartVersionId = '0';
            let clientChartStatus = '0';
            let appointmentServiceIds = '0';

            if (this.contextParams && this.contextParams.params) {
                var params = this.contextParams.params;                
                sourceModule = angular.isDefined(params["sourceModule"]) ? params["sourceModule"] : +Meevo.Model.ModuleEnum.System;
                period = angular.isDefined(params["period"]) ? params["period"] : 0;
                if (sourceModule == Meevo.Model.ModuleEnum.System) { period = 0; }
                mode = angular.isDefined(params["mode"]) ? params["mode"] : null;
                clientChartId = angular.isDefined(params["clientChartId"]) ? params["clientChartId"] : '0';
                locationId = angular.isDefined(params["locationId"]) ? params["locationId"] : '0';
                chartdefinitionId = angular.isDefined(params["chartdefinitionId"]) ? params["chartdefinitionId"] : '0';
                chartVersionId = angular.isDefined(params["chartVersionId"]) ? params["chartVersionId"] : '0';
                clientChartStatus = angular.isDefined(params["clientChartStatus"]) ? params["clientChartStatus"] : '0';
                appointmentServiceIds = angular.isDefined(params["appointmentServiceIds"]) && params["appointmentServiceIds"].length > 0 ? params["appointmentServiceIds"] : '0';
            }

            if (!period) { period = 0; }
            super.selected();
            const parentId = this.getParentItemId();
            if (mode) {
                targetRoute = `client/${parentId}/client-charts/${sourceModule}/${locationId}/${chartdefinitionId}/${clientChartId}/${chartVersionId}/${appointmentServiceIds}/${period}/${clientChartStatus}/${mode}`;
            }
            else {
                targetRoute = `client/${parentId}/client-charts-list/${sourceModule}/${period}`;
            }

            this.contextParams.addInteropParams({ id: 'interop:client', isInterop: true, targetRoute: targetRoute });
        }
    }
}


